import React from "react";
import "./NumberContainer.css";

const NumberContainer = ({ color, number }) => {
  return <div className={`${color} lottolegenda-number`}>{number}</div>;
};

export default NumberContainer;
